import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ArchiveIcon(props: IconProps) {
    return <Icon {...props} iconKey={"archive"}/>
}
